import DataTableKetQua from "./DataTableKetQua.jsx";
import DataTable from './DataTable.jsx'

export { DataTableKetQua };

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/data-table/index.js